import { useContext } from "react";
import { PageNewState, InfraTicketDescriptionDialogContext } from ".";

export const useInfraTicketDescriptionDialogState = () => {
  const { pageState, setPageState } = useContext(
    InfraTicketDescriptionDialogContext,
  );
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
